var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificateView"},[_c('div',{staticClass:"mainbox"},[_c('searchs',{staticClass:"banner",on:{"chooseList":_vm.getChooseList,"majorName":_vm.getMajorName}}),_c('connects',{staticClass:"banner",attrs:{"chooseList":_vm.chooseList,"majorName":_vm.majorName}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }